// extracted by mini-css-extract-plugin
export default {"cls1":"StickyCtaFooter-cls1_ZR_","cls2":"StickyCtaFooter-cls2_kJS StickyCtaFooter-cls1_ZR_"};